import React, { useState } from 'react';
import PropTypes from "prop-types";
import { Table, Button, UncontrolledTooltip, Badge } from 'reactstrap';
import { translate } from "react-translate";
import LoadingLocal from 'plugins/TS-lib-utils-public/components/Loading/LoadingLocal';
import { actionSetPatientEditData } from 'store/actions/usersActions';
import { useDispatch } from "react-redux";
import { useHistory } from 'react-router-dom';
import PatientDetailsModal from './PatientDetailsModal';

const TablePatientUsers = (props) => {
    const { data, loading } = props;
    const { t } = props;
    const dispatch = useDispatch();
    const history = useHistory();

    const [modalOpen, setModalOpen] = useState(false);
    const [selectedPatient, setSelectedPatient] = useState(null);

    const editUser = (e, user) => {
        e.preventDefault();
        dispatch(actionSetPatientEditData({...user}));
        history.push(`/admin/list-patients/edit/`);
    }

    const viewDetails = (e, user) => {
        e.preventDefault();
        setSelectedPatient(user);
        setModalOpen(true);
    }

    const toggleModal = () => setModalOpen(!modalOpen);

    const getSummary = (user) => {
        const details = user.associated_details || [];
        const practiceCount = details.length;
        
        // Count total doctors across all practices
        const totalDoctors = details.reduce((acc, curr) => acc + (curr.doctors ? curr.doctors.length : 0), 0);
        return { practiceCount, totalDoctors };
    }

    return (
        <>
            <PatientDetailsModal 
                isOpen={modalOpen} 
                toggle={toggleModal} 
                patient={selectedPatient} 
            />

            {loading ?
                (<LoadingLocal />)
                :
                (<div className="table-data">
                    <Table responsive>
                        <thead className="text-primary">
                            <tr>
                                <th> {t("firstName-user")}</th>
                                <th> {t("lastName-user")}</th>
                                <th> {t("email-user")}</th>
                                <th> {t("type-user")}</th>
                                <th> {"Verified"} </th>
                                <th> {"External ID"} </th>
                                <th className="text-center"> {t("relations-user")} </th>
                                <th className="text-right"> {t("actions")} </th>
                            </tr>
                        </thead>

                        {data.length > 0 && (data.map((p, index) => {
                            const { practiceCount, totalDoctors } = getSummary(p);
                            return (
                                <tbody key={index}>
                                    <tr>
                                        <td>{p.firstName}</td>
                                        <td>{p.lastName}</td>
                                        <td>{p.email}</td>
                                        <td>
                                            <Badge color="info">{p.membership}</Badge>
                                        </td>
                                        <td>
                                            <Badge color={p.is_ready ? "success" : "warning"}>
                                                {p.is_ready ? "Yes" : "No"}
                                            </Badge>
                                        </td>
                                        
                                        <td>
                                            {p.associated_details ? p.associated_details.map(p => {
                                                return <><small className="text-muted">{p.name}:</small> <b>{p.patient_ext_ref}</b><br/></>
                                            }) : "-"}
                                        </td>
                                        
                                        <td className="text-center">
                                            <div className="summary-badge">
                                                <i className="fa fa-hospital-o mr-1" />
                                                <span className="summary-highlight">{practiceCount}</span> {t("practice-count")}
                                            </div>
                                            <br/>
                                            <div className="summary-badge mt-1">
                                                <i className="fa fa-user-md mr-1" />
                                                <span className="summary-highlight">{totalDoctors}</span> {t("doctor-count")}
                                            </div>
                                        </td>

                                        <td className="text-right">
                                            <Button
                                                onClick={e => viewDetails(e, p)}
                                                className="btn-icon btn-round btn-neutral"
                                                color="info"
                                                size="sm"
                                                id={`tooltip-details-pat-${index}`}
                                            >
                                                <i className="fa fa-eye" />
                                            </Button>
                                            <UncontrolledTooltip placement="top" target={`tooltip-details-pat-${index}`}>
                                                {t("view-details")}
                                            </UncontrolledTooltip>

                                            <Button
                                                onClick={e => editUser(e, p)}
                                                className="btn-icon btn-round btn-neutral"
                                                color="warning"
                                                size="sm"
                                                id={`tooltip-edit-pat-${index}`}
                                            >
                                                <i className="fa fa-edit" />
                                            </Button>
                                            <UncontrolledTooltip placement="top" target={`tooltip-edit-pat-${index}`}>
                                                Edit Ref
                                            </UncontrolledTooltip>
                                        </td>
                                    </tr>
                                </tbody>
                            )
                        })
                        )}
                    </Table>
                </div>)}

        </>
    );
};
TablePatientUsers.defaultProps = {
    data: [],
    loading: true
};

TablePatientUsers.propTypes = {
    data: PropTypes.array,
    loading: PropTypes.bool
};

export default translate("userList-table")(TablePatientUsers);